import { z } from 'zod';

/**
 * Shared date-range query schema for any GET endpoint that filters by a
 * date window. Both fields are required strings in YYYY-MM-DD format.
 */
export const dateRangeQuerySchema = z.object({
  startDate: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'startDate must be in YYYY-MM-DD format'),
  endDate: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'endDate must be in YYYY-MM-DD format'),
});

export type DateRangeQuery = z.infer<typeof dateRangeQuerySchema>;
